export default [
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '天信价格评估系统'
        },
        children:[
          {
            path: '/',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '天信价格评估系统-控制台'
            },
          },
          {
            path: 'console',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '天信价格评估系统-控制台'
            },
          },
          {
            path: 'addAsset',//新增案件
            name: 'addAsset',
            component: () => import('@/views/main/addAsset/index'),
            meta: {
              title: '天信价格评估系统-新增案件'
            },
          },
          {
            path: '/toAccept',//待受理
            name: 'toAccept',
            component: () => import('@/views/main/addAsset/toAccept'),
            meta: {
              title: '天信价格评估系统-待受理'
            },
          },
          
          {
            path: '/assessCaseManage',//案件管理-评估
            name: 'assessCaseManage',
            component: () => import('@/views/main/caseManage/assess/index'),
            meta: {
              title: '天信价格评估系统-评估案件管理'
            },
          },
          {
            path: '/surveyCaseManage',//案件管理-调查
            name: 'surveyCaseManage',
            component: () => import('@/views/main/caseManage/survey/index'),
            meta: {
              title: '天信价格评估系统-调查案件管理'
            },
          },
          {
            path: '/propertyCaseManage',//案件管理-财产险
            name: 'propertyCaseManage',
            component: () => import('@/views/main/caseManage/property/index'),
            meta: {
              title: '天信价格评估系统-财产险案件管理'
            },
          },
          {
            path: '/allCaseManage',//案件管理-综合查询
            name: 'allCaseManage',
            component: () => import('@/views/main/caseManage/all'),
            meta: {
              title: '天信价格评估系统-综合案件管理'
            },
          },

          {
            path: '/materialDamage',//天信资产评估系统物损详情
            name: 'materialDamage',
            component: () => import('@/views/main/caseManage/materialDamage'),
            meta: {
              title: '天信价格评估系统-物损详情'
            },
          },
          {
            path: '/carDamage',//天信资产评估系统车损详情
            name: 'carDamage',
            component: () => import('@/views/main/caseManage/carDamage'),
            meta: {
              title: '天信价格评估系统-物损详情'
            },
          },
         
         
         
          {
            path: '/financeDamage',//天信资产评估系统财产险详情
            name: 'financeDamage',
            component: () => import('@/views/main/caseManage/financeDamage'),
            meta: {
              title: '天信价格评估系统-财产险详情'
            },
          },
          {
            path: '/carInsuranceDamage',//天信资产评估系统车险调查详情
            name: 'carInsuranceDamage',
            component: () => import('@/views/main/caseManage/carInsuranceDamage'),
            meta: {
              title: '天信价格评估系统-车险(调查)详情'
            },
          },

          {
            path: '/auditCase',//案件审核
            name: 'auditCase',
            component: () => import('@/views/main/auditCase/auditCase'),
            meta: {
              title: '天信价格评估系统-案件审核'
            },
          },
          {
            path: '/auditCaseAssess',//案件审核-评估案件
            name: 'auditCaseAssess',
            component: () => import('@/views/main/auditCase/assess'),
            meta: {
              title: '天信价格评估系统-案件审核-评估案件'
            },
          },
          {
            path: '/auditCaseProperty',//案件审核-财产险案件
            name: 'auditCaseProperty',
            component: () => import('@/views/main/auditCase/property'),
            meta: {
              title: '天信价格评估系统-案件审核-财产险案件'
            },
          },
          {
            path: '/auditCaseSurvey',//案件审核-调查案件
            name: 'auditCaseSurvey',
            component: () => import('@/views/main/auditCase/survey'),
            meta: {
              title: '天信价格评估系统-案件审核-调查案件'
            },
          },


          


          {
            path: '/entrustMaterial',//价格评估委托准许书
            name: 'entrustMaterial',
            component: () => import('@/views/main/entrust/material'),
            meta: {
              title: '价格评估委托书'
            },
          },
          {
            path: '/entrustCar',//委托书模板(车损)
            name: 'entrustCar',
            component: () => import('@/views/main/entrust/car'),
            meta: {
              title: '车损委托书'
            },
          },
          {
            path: '/entrustCommonCar',//委托书模板(车损共同)
            name: 'entrustCommonCar',
            component: () => import('@/views/main/entrust/commonCar'),
            meta: {
              title: '车损共同委托书'
            },
          },
          {
            path: '/entrustCarInsurance',//机动车辆保险调查委托函
            name: 'entrustCarInsurance',
            component: () => import('@/views/main/entrust/carInsurance'),
            meta: {
              title: '机动车辆保险调查委托函'
            },
          },

          {
            path: '/materialReport',//天信资产评估系统物损损失价格评估报告
            name: 'materialReport',
            component: () => import('@/views/main/report/materialReport'),
            meta: {
              title: '天信资产评估系统-物损损失价格评估报告'
            },
          },
          {
            path: '/carReport',//车损评估报告
            name: 'carReport',
            component: () => import('@/views/main/report/carReport'),
            meta: {
              title: '天信资产评估系统-车损评估报告'
            },
          },





          {
            path: '/menu',//菜单管理
            name: 'menu',
            component: () => import('@/views/main/system/menu'),
            meta: {
              title: '天信资产评估系统-菜单管理'
            },
          },
          {
            path: '/person',//人员管理
            name: 'person',
            component: () => import('@/views/main/system/person'),
            meta: {
              title: '天信资产评估系统-人员管理'
            },
          },
          {
            path: '/role',//角色管理
            name: 'role',
            component: () => import('@/views/main/system/role'),
            meta: {
              title: '天信资产评估系统-角色管理'
            },
          },
          {
            path: '/permissionSetting',//人员权限管理
            name: 'permissionSetting',
            component: () => import('@/views/main/system/permissionSetting'),
            meta: {
              title: '天信资产评估系统-人员权限管理'
            },
          },
          {
            path: '/organization',//角色管理
            name: 'organization',
            component: () => import('@/views/main/system/organization'),
            meta: {
              title: '天信资产评估系统-角色管理'
            },
          },
          {
            path: '/assessment',//角色管理
            name: 'assessment',
            component: () => import('@/views/main/system/assessment'),
            meta: {
              title: '天信资产评估系统-公估师管理'
            },
          },
          {
            path: '/insuranceCompany',//保险公司
            name: 'insuranceCompany',
            component: () => import('@/views/main/system/insuranceCompany'),
            meta: {
              title: '天信资产评估系统-保险公司'
            },
          },

          {
            path: '/template',//文件模板
            name: 'template',
            component: () => import('@/views/main/template/index'),
            meta: {
              title: '天信资产评估系统-文件模板'
            },
          },


          // {
          //   path: '/insuranceSubject',//保险主体报表
          //   name: 'insuranceSubject',
          //   component: () => import('@/views/main/data/insuranceSubject'),
          //   meta: {
          //     title: '天信资产评估系统-保险主体报表'
          //   },
          // },


          
          {
            path: '/assessDailyStatement',//评估日报表
            name: 'assessDailyStatement',
            component: () => import('@/views/main/data/assessDailyStatement'),
            meta: {
              title: '天信资产评估系统-评估日报表'
            },
          },
          {
            path: '/subjectDailyStatement',//主体日报表
            name: 'subjectDailyStatement',
            component: () => import('@/views/main/data/subjectDailyStatement'),
            meta: {
              title: '天信资产评估系统-主体日报表'
            },
          },


          {
            path: '/updatePassword',//修改密码
            name: 'updatePassword',
            component: () => import('@/views/main/updatePassword'),
            meta: {
              title: '天信资产评估系统-修改密码'
            },
          },
        ]
          
      },

]